module.exports = "/assets/a3044eb1edb6551244e896d6458c8ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TZ.png
// module id = 1874
// module chunks = 0